"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Activity = void 0;
const ActivityList_1 = require("./ActivityList");
const types_1 = require("./types");
class Activity {
    constructor(data) {
        this.dateStart = null;
        this.dateEnd = null;
        this.id = data.id;
        this.name = data.name;
        this.title = data.title;
        this.description = data.description;
        this.image = data.image;
        this.activity_id = data.activity_id;
        this.base_num_points = data.base_num_points;
        this.num_points = data.num_points;
        this.category_id = data.category_id;
        this.category_name = data.category_name;
        this.type_id = data.type_id;
        this.type_name = data.type_name;
        this.activity_channel_id = data.activity_channel_id;
        this.activity_channel_name = data.activity_channel_name;
        this.freq_cap = data.freq_cap;
        this.freq_period_id = data.freq_period_id;
        this.freq_period_name = data.freq_period_name;
        this.freq_num_required_attempts = data.freq_num_required_attempts;
        this.redirect_url = data.redirect_url;
        this.points_on_click = data.points_on_click;
        this.action_tags = data.action_tags;
        this.date_awarded = data.date_awarded;
        this.date_created = data.date_created;
        this.extra_data = data.extra_data;
        this.base_extra_data = data.base_extra_data;
        this.public_title = data.public_title;
        this.public_description = data.public_description;
        this.date_start = data.date_start;
        this.date_end = data.date_end;
        this.min_tier_id = data.min_tier_id;
        this.user_num_completions = data.user_num_completions;
        this.group_user_num_completions = data.group_user_num_completions;
        this.group_frequency = data.group_frequency;
        this.is_hidden_by_tier = data.is_hidden_by_tier;
        this.is_locked_by_tier = data.is_locked_by_tier;
        this.campaigns = data.campaigns;
    }
    get isFeatured() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('layout') &&
            this.extra_data.layout === 'featured');
    }
    get isVideo() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'video'.toUpperCase());
    }
    get isExpressGame() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'interactive_game'.toUpperCase());
    }
    get isAudio() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'audio'.toUpperCase());
    }
    get isDocument() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'read_document'.toUpperCase());
    }
    get isInformationOnly() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('is_information_only') &&
            !!this.extra_data.is_information_only);
    }
    get isCollectThemAll() {
        var _a, _b;
        return !!((_a = this.extra_data) === null || _a === void 0 ? void 0 : _a.is_collect_them_all) && !!((_b = this.extra_data) === null || _b === void 0 ? void 0 : _b.super_bonus_key);
    }
    get isURL() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'view_url'.toUpperCase());
    }
    get isScanTicket() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('layout') &&
            this.extra_data.layout === 'scan_ticket');
    }
    get isUploadPhoto() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'upload_photo'.toUpperCase());
    }
    get isSocialConnect() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'social_connect'.toUpperCase());
    }
    get isInviteFriend() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'invite_friend'.toUpperCase());
    }
    get isProfileCompletion() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'profile_completion'.toUpperCase());
    }
    get isNotificationPreference() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'notification_preference'.toUpperCase());
    }
    get isPushNotificationPreference() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('action_type') &&
            typeof this.extra_data.action_type === 'string' &&
            this.extra_data.action_type.toUpperCase() === 'push_notification_preference'.toUpperCase());
    }
    get isMobileAppSignInBonus() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('layout') &&
            this.extra_data.layout === 'mobile_app_sign_in');
    }
    get isVisibleOnListPage() {
        return !this.isMobileAppSignInBonus;
    }
    get isVisibleOnMobileListPage() {
        return this.isVisibleOnListPage && !this.isWebOnly;
    }
    get isVisibleOnWebListPage() {
        return this.isVisibleOnListPage && !this.isMobileOnly;
    }
    get isWebOnly() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('view') &&
            this.extra_data.view === 'web_only');
    }
    get isMobileOnly() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('view') &&
            this.extra_data.view === 'mobile_only');
    }
    get isBrowserView() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('view') &&
            this.extra_data.view === 'is_not_web_view');
    }
    get isHiddenFromList() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('view') &&
            this.extra_data.view === 'hidden');
    }
    get isPromoCode() {
        return ((!!this.type_id && this.type_id === types_1.ActivityType['Code Redemption']) ||
            (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'promo_code'.toUpperCase()));
    }
    get isSystemSurvey() {
        return this.extra_data ? this.extra_data.hasOwnProperty('system_survey') : false;
    }
    get isSurvey() {
        return this.activity_channel_id === types_1.ActivityChannelType.Survey;
    }
    get isLegacySurvey() {
        var _a;
        return this.isSurvey && !!((_a = this.extra_data) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('legacy_survey'));
    }
    get isPoll() {
        var _a;
        return (!!this.type_id &&
            this.type_id === types_1.ActivityType.Poll &&
            ((_a = this.activity_channel_name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'poll');
    }
    get isQuiz() {
        return this.activity_channel_id === types_1.ActivityChannelType.Quiz;
    }
    get gameUrl() {
        return !!this.extra_data && this.extra_data.hasOwnProperty('game_url')
            ? this.extra_data.game_url
            : '';
    }
    get gameName() {
        return !!this.extra_data && this.extra_data.hasOwnProperty('gameName')
            ? this.extra_data.gameName
            : '';
    }
    get gameNumber() {
        return !!this.extra_data && this.extra_data.hasOwnProperty('game_number')
            ? this.extra_data.game_number
            : '';
    }
    get portraitMode() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('game_view') &&
            this.extra_data.game_view === 'portrait');
    }
    get customOrder() {
        return !!this.extra_data && this.extra_data.hasOwnProperty('custom_order_override')
            ? parseInt(this.extra_data.custom_order_override, 10)
            : 0;
    }
    get campaignGroupId() {
        return !!this.extra_data && this.extra_data.hasOwnProperty('campaign_group_id')
            ? this.extra_data.campaign_group_id
            : '';
    }
    get isDebug() {
        return (!!this.extra_data &&
            this.extra_data.hasOwnProperty('debug') &&
            this.extra_data.debug === 'true');
    }
    get totalBonusPoints() {
        if (this.campaigns && this.campaigns.length > 0) {
            const totalPointsCampaigns = this.campaigns.map((campaign) => {
                if (!!campaign['multiplier']) {
                    return this.num_points * campaign['multiplier'];
                }
                else if (!!campaign['point_gift']) {
                    return this.num_points + campaign['point_gift'];
                }
                else {
                    return 0;
                }
            });
            return Math.max(...totalPointsCampaigns);
        }
        return 0;
    }
}
exports.Activity = Activity;
Activity.JsonToActivities = (data) => {
    const activityList = new ActivityList_1.ActivityList();
    data.forEach(activity => {
        if (!!activity.extra_data &&
            activity.extra_data.hasOwnProperty('view') &&
            activity.extra_data.view === 'hidden')
            return;
        activityList.push(Activity.JsonToActivity(activity));
    });
    return activityList.getDateStartSorted();
};
Activity.JsonToActivity = (data) => new Activity(data);
//# sourceMappingURL=Activity.js.map